<div class="container">
    <div class="row justify-content-center ui-web-home-schedule__content">
        <div class="col-lg-2 col-6 ui-web-home-schedule__content__container">
            <div class="ui-web-home-schedule__content-item">
                <span class="drc-logo--circle"><img src="assets/img/drc-logo--circle.png" alt="DRC Logo"></span>
                <span class="title">Holy Mass</span>
                <span class="days">Monday - Thursday</span>
                <span class="time" *ngIf="winter_schedule">6:00 PM</span>
                <span class="time" *ngIf="!winter_schedule">7:30 AM & 6:30 PM</span>
            </div>
        </div>
        <div class="col-lg-2 col-6 ui-web-home-schedule__content__container">
            <div class="ui-web-home-schedule__content-item">
                <span class="drc-logo--circle"><img src="assets/img/drc-logo--circle.png" alt="DRC Logo"></span>
                <span class="title">Friday Service</span>
                <span class="time">6:00 PM - 9:00 PM</span>
            </div>
            </div>
        <div class="col-lg-2 col-6 ui-web-home-schedule__content__container">
            <div class="ui-web-home-schedule__content-item">
                <span class="drc-logo--circle"><img src="assets/img/drc-logo--circle.png" alt="DRC Logo"></span>
                <span class="title">Daily Adoration</span>
                <span class="days">Monday - Friday</span>
                <span class="time">9:00 AM - 5:30 PM</span>
            </div>
        </div>
        <div class="col-lg-2 col-6 ui-web-home-schedule__content__container">
            <div class="ui-web-home-schedule__content-item">
                <span class="drc-logo--circle"><img src="assets/img/drc-logo--circle.png" alt="DRC Logo"></span>
                <span class="title">Night Vigil</span>
                <span class="days">3<sup>rd</sup> Saturday</span>
                <span class="time">7:00 PM - 10:00 PM</span>
            </div>
        </div>
        <div class="col-lg-2 col-6 ui-web-home-schedule__content__container">
            <div class="ui-web-home-schedule__content-item">
                <span class="drc-logo--circle"><img src="assets/img/drc-logo--circle.png" alt="DRC Logo"></span>
                <span class="title">Children & Teens Prayer Service</span>
                <span class="days">1<sup>st</sup> Saturday</span>
                <span class="time">10:00 AM - 3:00 PM</span>
            </div>
        </div>
        <div class="col-lg-2 col-6 ui-web-home-schedule__content__container">
            <div class="ui-web-home-schedule__content-item">
                <span class="drc-logo--circle"><img src="assets/img/drc-logo--circle.png" alt="DRC Logo"></span>
                <span class="title">Confession</span>
                <span class="days">Friday</span>
                <span class="time">5:15 PM - 6:00 PM</span>
                <span class="days">Monday - Thursday</span>
                <span class="time">By Appointment Only</span>
            </div>
        </div>
    </div>
</div>